import { Company } from 'shared-pages/common/constants';
import { ICollectionLine } from 'shared-pages/pages/collections/form/collectionExtras-table';

export const version = '1.0.0';

export enum UserRoles {
  All = 0,
  Admin = 1,
}

export const FILESREPO_S3FOLDER = 'filesrepo';

export enum Modelnames {
  User = 'User',
}

export const DEFAULT_MATERIALS: ICollectionLine[] = [];
